export default __webpack_public_path__ + "static/media/products-2.4a46e780.webp";